import { useEffect, useState } from 'react';
import { Button, Card, Container, Grid, Stack, TextField, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import Page from '../../components/Page';
import BackButton from '../../components/BackButton';
import Desktop from '../../layouts/Desktop';
import instance from '../../api/axiosRequest';
import Phone from '../../layouts/Phone';
import openNotification from '../../components/notification';
import { findDynamicText, replaceDynamicText } from '../../utils/emailHtmltools';

export default function ExecuteCampaign() {
  const navigate = useNavigate();
  const [templateHTML, setTemplateHTML] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const [device, setDevice] = useState('desktop');
  const [loading, setLoading] = useState(false);
  const [wordsToReplace, setWordsToReplace] = useState([]);
  const [originalTemplate, setOriginalTemplate] = useState('');
  const [replacementTemplateData, setReplacementTemploateData] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    const campain = searchParams.get('campaignName');
    try {
      setLoading(true);
      await instance.post('/mail/executeEmailCampain', {
        campain,
        replacementTemplateData,
      });
      setLoading(false);
      openNotification({ message: 'Campaign executed successfully.', type: 'success' });
      navigate(-1);
    } catch (error) {
      setLoading(false);
      openNotification({ message: 'Campaign not executed successfully.', type: 'error' });
      console.log(error);
    }
  };

  useEffect(() => {
    const getTemplateDetails = async () => {
      try {
        const { data } = await instance.post('/mail/templateDetails', {
          templateName: searchParams.get('templateName'),
        });
        const htmlPart = data.data.Template.HtmlPart;
        setOriginalTemplate(htmlPart);
        setWordsToReplace(findDynamicText(htmlPart));
        setTemplateHTML(htmlPart);
      } catch (error) {
        console.log(error);
      }
    };
    getTemplateDetails();
  }, []);

  const handleChange = (e) => {
    setReplacementTemploateData((state) => ({
      ...state,
      [e.target.name]: e.target.value,
    }));
    setTemplateHTML(
      replaceDynamicText(originalTemplate, {
        ...replacementTemplateData,
        [e.target.name]: e.target.value,
      })
    );
  };

  return (
    <Page title="Execute Email Campaign">
      <Container>
        <BackButton />
        <Card sx={{ p: 4 }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={9}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                  <Typography variant="h5">Preview</Typography>
                  <Stack direction="row" spacing={2}>
                    <Button
                      onClick={() => setDevice('desktop')}
                      variant={device === 'desktop' ? 'contained' : 'outlined'}
                    >
                      Desktop
                    </Button>
                    <Button onClick={() => setDevice('phone')} variant={device === 'phone' ? 'contained' : 'outlined'}>
                      Phone
                    </Button>
                  </Stack>
                </Stack>
                {device === 'desktop' ? <Desktop text={templateHTML} /> : <Phone text={templateHTML} />}
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography variant="h5" mb={2} mt={8}>
                  Replace Text
                </Typography>
                {wordsToReplace.map((word) => (
                  <TextField
                    key={word}
                    label={word}
                    name={word}
                    value={replacementTemplateData[word]}
                    onChange={handleChange}
                  />
                ))}{' '}
                <br />
                <LoadingButton type="submit" sx={{ mt: 2 }} loading={loading} variant="contained">
                  Send
                </LoadingButton>
              </Grid>
            </Grid>
          </form>
        </Card>
      </Container>
    </Page>
  );
}
